import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '@/views/HomePage.vue'
import HelpRequest from '@/views/HelpRequest.vue'
import AdminDashboard from '@/views/AdminDashboard.vue'
import AboutPage from '@/views/AboutPage.vue'
import FAQPage from '@/views/FAQPage.vue'
import JoinPage from '@/views/JoinPage.vue'
import PartnersPage from '@/views/PartnersPage.vue'
import SupportPage from '@/views/SupportPage.vue'
import BecomePartner from '@/views/BecomePartner.vue'
import PublishPage from '@/views/PublishPage.vue'
import AdminContacts from '@/views/AdminContacts.vue'
import RequestDetails from '@/views/RequestDetails.vue'
import LoginPage from '@/views/LoginPage.vue'
import RegisterPage from '@/views/RegisterPage.vue'
import MyRequests from '@/views/MyRequests.vue'
import MyAccount from '@/views/MyAccount.vue'
import AdminDeleteRequests from '@/views/AdminDeleteRequests.vue'
import AdminEvents from '@/views/AdminEvents.vue'
import EventDetails from '@/views/EventDetails.vue'
import CreateEvent from '@/views/CreateEvent.vue'
import UsersAdmin from '@/views/UsersAdmin.vue'
import EventsPage from '@/views/EventsPage.vue'
import UserSearchPage from '@/views/UserSearchPage.vue'
import UserProfilePage from '@/views/UserProfilePage.vue'
import "@/services/authInterceptor"

const routes = [
  {
    path: '/',
    component: HomePage
  },

  {
    path: '/help',
    component: HelpRequest,
     meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/about',
    component: AboutPage
  },

  {
    path: '/faq',
    component: FAQPage
  },

  {
    path: '/join',
    component: JoinPage
  },

  {
    path: '/partners',
    component: PartnersPage
  },

  {
    path: '/support',
    component: SupportPage
  },

  {
    path: '/become',
    component: BecomePartner
  },

  {
    path: '/login',
    component: LoginPage
  },

  {
    path: '/register',
    component: RegisterPage
  },

  {
    path: '/requests/:publicId',
    name: 'request-details',
    component: RequestDetails
  },

  {
    path: '/my-requests',
    component: MyRequests
  },

  {
    path: '/account',
    name: 'account',
    component: MyAccount
  },

  // =========================
  // PAGES ADMIN
  // =========================

  {
    path: '/dashboard',
    component: AdminDashboard,
    meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/events-management',
    component: AdminEvents,
    meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/contacts',
    component: AdminContacts,
    meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/users',
    component: UsersAdmin,
    meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/delete-requests',
    name: 'DeleteRequests',
    component: AdminDeleteRequests,
    meta: {
      requiresAdmin: true
    }
  },

  // =========================
  // PAGES PUBLIQUES
  // =========================

  {
    path: '/events',
    component: EventsPage
  },

  {
    path: "/events/:publicId",
    component: EventDetails
  },

  {
    path: '/createEvents',
    component: CreateEvent,
     meta: {
      requiresAdmin: true
    }
  },

  {
    path: '/publish',
    component: PublishPage
  },

  {
    path: '/search',
    component: UserSearchPage
  },

  {
    path: '/profile/:id',
    component: UserProfilePage
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// =========================
// PROTECTION ADMIN
// =========================

router.beforeEach((to, from, next) => {

  // Route normale
  if (!to.meta.requiresAdmin) {
    next()
    return
  }

  // Récupération de l'utilisateur connecté
  const savedUser = localStorage.getItem('user')

  // Pas connecté
  if (!savedUser) {
    next('/login')
    return
  }

  let user

  try {
    user = JSON.parse(savedUser)
  } catch (error) {
    localStorage.removeItem('user')
    next('/login')
    return
  }

  // Connecté mais pas administrateur
  if (user.role !== 'Admin') {
    next('/')
    return
  }

  // Administrateur
  next()
})

export default router